const mode = import.meta.env.MODE;
let baseUrl: string;

if (mode === 'production') {
  baseUrl = 'https://askawatch.cbre.com';
  console.log('Feedback: PRODUCTION mode');
} else if (mode === 'staging') {
  baseUrl = 'https://askawatch-test.cbre.com';
  console.log('Feedback: STAGING mode');
} else {
  baseUrl = 'http://localhost:8000';
  console.log('Feedback: DEVELOPMENT mode');
}

export interface SendFeedbackResponse {
  success: boolean;
  message: string;
}

export interface FeedbackItem {
    id: number | string;
    email: string;
    feature: string;
    feedback_text: string;
    submitted_at: string; // "YYYY-MM-DD HH:MM:SS" (UTC/DB time)
  }
  
  export interface FetchFeedbacksResponse {
    success: boolean;
    feedbacks: FeedbackItem[];
  }

export async function sendFeedback(
  user_email: string,
  feature: string,
  feedback_text: string
): Promise<SendFeedbackResponse> {
  const params = new URLSearchParams({
    user_email,
    feature,
    feedback_text
  }).toString();

  const res = await fetch(`${baseUrl}/api/feedback/send_feedback?${params}`, {
    method: 'GET',
    headers: { Accept: 'application/json' }
  });

  if (!res.ok) throw new Error(`Failed to send feedback (${res.status})`);
  return await res.json();
}

export async function fetchFeedbacks(): Promise<FetchFeedbacksResponse> {
    const res = await fetch(`${baseUrl}/api/feedback/fetch_feedback`, {
      method: 'GET',
      headers: { Accept: 'application/json' }
    });
  
    if (!res.ok) {
      const text = await res.text();
      throw new Error(`Failed to fetch feedbacks (${res.status}): ${text}`);
    }
  
    const data = await res.json();
    // Basic shape validation
    if (!data || typeof data.success !== 'boolean' || !Array.isArray(data.feedbacks)) {
      throw new Error('Invalid fetchFeedbacks response shape');
    }
    return data as FetchFeedbacksResponse;
  }
